/**
 * OrbDocCoreConceptsEntitiesSLOrbDocCoreConceptsEntitiesSLPage
 *
 * Page component for OrbDocCoreConceptsEntitiesSLOrbDocCoreConceptsEntitiesSLPage
 * Path: /sl/docs/core-concepts/entities
 *
 * @generated from schema
 */

import React from 'react';
import { useLocation } from 'react-router-dom';
import type { EventPayload } from '@almadar/core';
import { OrbDocCoreConceptsEntitiesSLDocScreenView as __OrbDocCoreConceptsEntitiesSLDocScreenView } from '@/components/traits/OrbDocCoreConceptsEntitiesSLDocScreenView';
import { OrbDocCoreConceptsEntitiesSLDocAnalyticsView as __OrbDocCoreConceptsEntitiesSLDocAnalyticsView } from '@/components/traits/OrbDocCoreConceptsEntitiesSLDocAnalyticsView';
import { VStack, UISlotComponent } from '@almadar/ui/components';
import { usePageHead } from '@almadar/ui/hooks';

interface OrbDocCoreConceptsEntitiesSLOrbDocCoreConceptsEntitiesSLPageProps {
  // Add any page-level props here
}

export function OrbDocCoreConceptsEntitiesSLOrbDocCoreConceptsEntitiesSLPage(_props: OrbDocCoreConceptsEntitiesSLOrbDocCoreConceptsEntitiesSLPageProps) {
  const __location = useLocation();
  const __navState = (__location.state ?? {}) as EventPayload;

  usePageHead({ "title":"Entitete","description":"Podatki, ki jih ima orbital, kje so shranjeni in kdo jih sme brati ali spreminjati.","access":"public","indexing":"index","origin":"https://orb.almadar.io","siteName":"Orb","alternates":[{"locale":"en","path":"/docs/core-concepts/entities"},{"locale":"ar","path":"/ar/docs/core-concepts/entities"},{"locale":"sl","path":"/sl/docs/core-concepts/entities"}],"defaultLocale":"en", path: __location.pathname });

  return (
    <>
      <UISlotComponent slot="main">
        <VStack gap="lg" className="w-full">
          <__OrbDocCoreConceptsEntitiesSLDocScreenView config={{ initPayload: __navState }} />
          <__OrbDocCoreConceptsEntitiesSLDocAnalyticsView config={{ initPayload: __navState }} />
        </VStack>
      </UISlotComponent>
    </>
  );
}

export default OrbDocCoreConceptsEntitiesSLOrbDocCoreConceptsEntitiesSLPage;
